module.exports = __webpack_public_path__ + "media/images/iconPaginateLast-f8d61dbd3fbbd6a183f20d601ab12dc7.png";